import { GripVertical, Trash2 } from 'lucide-react';
import React from 'react';
import { useChatbot } from '../../contexts/ChatbotContext';
import { useGallerySystem } from '../../hooks/useGallerySystem';

export function GalleryImageList() {
  const { chatbotPublicId } = useChatbot();
  const { images, deleteImage, reorderImages, loading } = useGallerySystem();
  const [draggedIndex, setDraggedIndex] = React.useState<number | null>(null);

  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  const handleDragOver = async (e: React.DragEvent, index: number) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index || !chatbotPublicId) return;

    const newImages = [...images];
    const draggedImage = newImages[draggedIndex];
    newImages.splice(draggedIndex, 1);
    newImages.splice(index, 0, draggedImage);

    await reorderImages(chatbotPublicId, newImages.map(img => img.id));
    setDraggedIndex(index);
  };

  const handleDelete = async (imageId: string) => {
    if (!chatbotPublicId) return;
    await deleteImage(chatbotPublicId, imageId);
  };

  if (images.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">No images in the gallery</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {images.map((image, index) => (
        <div
          key={image.id}
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => handleDragOver(e, index)}
          onDragEnd={() => setDraggedIndex(null)}
          className={`group relative aspect-square rounded-lg overflow-hidden border border-white/10 ${
            loading.delete || loading.reorder ? 'opacity-50' : ''
          }`}
        >
          <img
            src={image.url}
            alt={image.title || ''}
            className="w-full h-full object-cover"
          />
          
          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4">
            <button
              onClick={() => handleDelete(image.id)}
              className="p-2 rounded-lg bg-red-500/20 text-red-400 hover:bg-red-500/30 transition-colors"
              disabled={loading.delete}
            >
              <Trash2 className="w-5 h-5" />
            </button>
            <div className="p-2 text-gray-400 cursor-move">
              <GripVertical className="w-5 h-5" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}